module.exports = __webpack_public_path__ + "static/img/case3.4383c93.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/index/images/case3.png
// module id = 5Rh8
// module chunks = 1